import { render, staticRenderFns } from "./xglhc_mobile.vue?vue&type=template&id=759cc259&"
import script from "./xglhc_mobile.vue?vue&type=script&lang=js&"
export * from "./xglhc_mobile.vue?vue&type=script&lang=js&"
import style0 from "./xglhc_mobile.vue?vue&type=style&index=0&id=759cc259&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports